export const selectReports = state => state.entities.reports;

export const selectReport = (state, id) => selectReports(state).byId[id];
export const selectNewReport = state => selectReports(state).new;
export const selectTempReport = (state, id) => selectReports(state).temporary[id];
